import {
  Box,
  Paper,
  Grid,
  Button,
} from '@mui/material';

import { Typography } from '@material-ui/core';

import { useTranslation } from 'react-i18next';
import ClearIcon from '@mui/icons-material/Clear';
import { useDispatch, useSelector } from 'react-redux';

import filterListWrapperStyle from './filterListWrapperStyle';
import { namespaces } from '../../../../../../i18n/i18n.constants';
import WORKERS_FILTERS from '../../../../../../config/filtersConfig/workersFilters';
import CIVIL_WORKS_FILTERS from '../../../../../../config/filtersConfig/civilWorksFilters';
import { ObjectType } from '../../../../../../types/objectType';
import { removeWorkersFilters, removeCivilWorksFilters } from '../../../../../../redux/modules/civilWorkWorkerList';

interface FilterListWrapperProps {
  children: JSX.Element[],
  filterListTitle: string,
  // ACPQ1-1188 - Add columnType to know which filters to clear
  columnType?: 'workers' | 'civilWorks'
}

export const FilterListWrapper = (props: FilterListWrapperProps) => {
  const { children, filterListTitle, columnType } = props;
  const classes = filterListWrapperStyle();
  const { t } = useTranslation(namespaces.pages.resumesSearch);

  const { filters } = useSelector((store: any) => store.civilWorksPersonLists);

  // ACPQ1-1188 - Determine which filters to consider based on columnType
  const FILTERS_LIST = columnType === 'workers' ? WORKERS_FILTERS : CIVIL_WORKS_FILTERS;
  const currentFilters: ObjectType = Object.fromEntries(
    Object.entries(filters).filter(([key]) => FILTERS_LIST.includes(key)),
  );

  // ACPQ1-1188 - Disable clear button if no filters are applied
  const disabled = Object.keys(currentFilters).length === 0
    || Object.values(currentFilters).every((val) => !val);

  const dispatch = useDispatch();
  const buttonColor = '#555555';

  // ACPQ1-1188 - Handle clear filters button click according to columnType
  const handleClearFilters = () => {
    if (columnType === 'workers') {
      dispatch(removeWorkersFilters(filters));
    } else if (columnType === 'civilWorks') {
      dispatch(removeCivilWorksFilters(filters));
    }
  };

  return (
    <Grid
      className={classes.filterContainer}
    >
      <Paper
        className={classes.filterPaper}
        elevation={0}
      >
        <Box pt={2} pl={2} mb={2} className={classes.flexBox} >
          <Typography variant="h5" component="div">{t(`titles.${filterListTitle}`)}</Typography>
          {columnType && <Button
            disabled={disabled}
            disableElevation
            onClick={handleClearFilters}
            startIcon={<ClearIcon />}
            variant='outlined'
            sx={{
              borderRadius: '20px',
              fontSize: '14px',
              textTransform: 'none',
              color: buttonColor,
              minWidth: '150px',
              borderColor: buttonColor,
              ':hover':
              {
                borderColor: '#E4E4E4',
                backgroundColor: '#E4E4E4',
              },
              ':active':
              {
                borderColor: '#BBBBBB',
                backgroundColor: '#BBBBBB',
              },
              marginRight: '5px',
            }}
          >
            {t('button.clearFilters')}
          </Button>
          }
        </Box>
        <Box
          className={classes.infiniteScroll}
        >
          {children}
        </Box>
      </Paper>
    </Grid>
  );
};
